import { useLang } from "./lang";

/**
 * While a tab loads, a placeholder card; when the server can't be reached,
 * a sentence and a way to try now — never a lone "…" (demo-ready Task 8).
 * The query keeps retrying on its own; "Try now" only skips the wait.
 */
export function Loading({ q }: { q: { isError: boolean; refetch: () => unknown } }) {
  const { t } = useLang();
  if (q.isError) {
    return (
      <div className="pwa-empty" role="alert">
        {t({ en: "Can't reach WorkForceOS — trying again.", ar: "تعذّر الوصول إلى WorkForceOS — نحاول مجدداً." })}{" "}
        <button type="button" className="pwa-btn" onClick={() => void q.refetch()}>
          {t({ en: "Try now", ar: "حاول الآن" })}
        </button>
      </div>
    );
  }
  return (
    <div className="pwa-list" aria-busy="true">
      <div className="pwa-card pwa-skeleton" data-testid="loading-card">
        <div className="pwa-skel-line" />
        <div className="pwa-skel-line short" />
      </div>
    </div>
  );
}
